import colors from "constants/colors";
import React from "react";
import Select from "react-select";
import { mapMultiClassnames } from "utils/map-modifier";
import "./index.scss";

export interface OptionProps {
  value: string;
  label: string;
  modifiers?: Modifiers;
  className?: string;
}

interface Select2Props {
  modifiers?: Modifiers;
  className?: string;
  options?: OptionProps[];
  placeholder?: string;
  openMenuOnClick?: boolean;
  isSearchable?: boolean;
  required?: any;
  name?: string;
  onChange?: any;
  value?: any;
  disabled?: boolean;
}

const Select2: React.FC<Select2Props> = ({
  onChange,
  value,
  options,
  required,
  isSearchable,
  openMenuOnClick,
  placeholder,
  disabled,
  modifiers,
  name,
}) => {
  return (
    <Select
      onChange={onChange}
      value={value || (options && options[0])}
      defaultValue={value || (options && options[0])}
      required={required}
      isSearchable={isSearchable}
      openMenuOnClick={openMenuOnClick}
      placeholder={placeholder}
      options={options}
      styles={{
        option: (base, state) => ({
          ...base,
          color: state.isSelected ? colors.white : colors.black,
          backgroundColor: state.isSelected
            ? colors.richElectricBlue
            : colors.white,
        }),
      }}
      isDisabled={disabled}
      className={mapMultiClassnames("a-select2", modifiers)}
      name={name}
    />
  );
};

Select2.defaultProps = {};

export default Select2;
